export default {
  //baseUrl: "https://shibei.dev.cintoe.com", //开发环境
  // baseUrl: "http://localhost:18080",
  // baseWsUrl: "ws://127.0.0.1:18080/api/websocket",

  baseWsUrl: "wss://shibei-h5.cintoe.com/api/websocket",
  baseUrl: "https://shibei-h5.cintoe.com",
  appId: "wx2613a2f5f53e3422"
};
